import { Factory, TemplateSalary, TrailerScreen, Transport, TransportBrand, Unit } from '../../pages';

export const routingDictionary = [
  {
    path: '/unit',
    exact: true,
    component: Unit,
    claims: ['CanLookBookSection'],
  },
  {
    path: '/factory',
    exact: true,
    component: Factory,
    claims: ['CanLookBookSection'],
  },

  {
    path: '/transport',
    exact: true,
    component: Transport,
    claims: ['all'],
  },
  {
    path: '/trailers',
    exact: true,
    component: TrailerScreen,
    claims: ['all'],
  },
  {
    path: '/transport-brand',
    exact: true,
    component: TransportBrand,
    claims: ['CanLookBookSection'],
  },
  {
    path: '/template-salary',
    exact: true,
    component: TemplateSalary,
    claims: ['CanLookBookSection'],
  },
];
